import React from "react";
import { Row, Col } from "antd";
import Img from "../../image/contact/help.png";
import { help } from "../../Data/E_Offer";

const Help= () => {
  return (
       <section  className="extra-effort py-[80px] px-[1rem]">
      <div className="container m-auto">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="center"
          className="overflow-hidden"
        >
          {/* Left: Image */}
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="mission-images">
              <img
                src={Img}
                className="w-[100%] lg:w-[90%]  h-[90%] object-contain rounded-lg "
                alt="img"
              />
            </div>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="banner-text">
                <h4 className="font-outfit text-sm  md:text-base text-[#555]">
               Contact
               </h4> 
              <h2 className="text-[40px] lg:text-[60px] font-cinzel text-start">
                How Can We Help?
              </h2>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit ">
              Direct your inquiry to the right team for faster support and clearer communication.
              </p>
               <div className="mt-[1rem]">
                   {help.map((data,index)=>(
                      <div key={index} className="flex flex-col gap-[9px] gap-[10px] mt-[0.8rem]">
                         <h2 className="font-cinzel text-[22px]">{data.title}</h2>
                         <p className="font-outfit text-[18px]">{data.detail}</p>
                      </div>
                   ))}
               </div>
             
            </div>
             {/* Right: Text */}
          </Col>
         
        </Row>
      </div>
    </section>
  )
}

export default Help
